"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/TestimonialCarouselComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TestimonialCarouselItem_1 = __importDefault(require("../TestimonialCarouselComponent/TestimonialCarouselItem"));
var TestimonialCarouselComponent = /** @class */ (function (_super) {
    __extends(TestimonialCarouselComponent, _super);
    function TestimonialCarouselComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TestimonialCarouselComponent.prototype.render = function () {
        var _this = this;
        var hasLink = (this.props.LinkTitle !== '' && this.props.LinkTitle !== null) && (this.props.LinkUrl !== '' && this.props.LinkUrl !== null);
        var button;
        if (hasLink) {
            button = react_1.default.createElement("div", { className: "carousel-button" },
                react_1.default.createElement("a", { href: this.props.LinkUrl, className: "btn btn-primary" }, this.props.LinkTitle));
        }
        return (react_1.default.createElement("div", { className: "col-md-6 col-sm-12 pb-40" },
            react_1.default.createElement("div", { id: "testimonialCarousel_" + this.props.UniqueKey, className: "carousel slide", "data-ride": "carousel" },
                react_1.default.createElement("div", { className: "carousel-inner", role: "listbox" }, this.props.Items.map(function (item, i) {
                    return react_1.default.createElement(TestimonialCarouselItem_1.default, { key: item.UniqueKey, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Author: item.Author, Organisation: item.Organisation, Statement: item.Statement, IsActive: item.IsActive });
                })),
                react_1.default.createElement("div", { className: "carousel-indicators-section" },
                    button,
                    react_1.default.createElement("ol", { className: "carousel-indicators testimonial" }, this.props.Items.map(function (item, i) {
                        return react_1.default.createElement("li", { key: "testimonialIndicator_" + _this.props.UniqueKey + "_" + i, "data-target": "#testimonialCarousel_" + _this.props.UniqueKey, "data-slide-to": i, className: item.IsActive ? 'active' : '' });
                    }))))));
    };
    return TestimonialCarouselComponent;
}(react_1.default.Component));
exports.default = TestimonialCarouselComponent;
